import * as types from '../constants/actionTypes';
import { wrapCall } from '../utils/serviceUtils';
import { api } from '../services';

export const openImportSourcesModal = () => ({
  type: types.OPEN_IMPORT_SOURCES_MODAL
});
export const dismissImportSourcesModal = () => ({
  type: types.DISMISS_IMPORT_SOURCES_MODAL
});

export const importXLS = (dsa, uuid, file) => {
  let formData = new FormData();
  formData.append('dsa', dsa.id);
  formData.append('xls', file);

  return wrapCall(
    api.post('/xls/dsa/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),
    'import_xls',
    { dsa, uuid, file }
  );
};

export const importXLSFiles = (dsa, files) => {
  let formData = new FormData();
  formData.append('dsa', dsa.id);
  formData.append('uuids', JSON.stringify(Object.keys(files)));
  Object.keys(files).forEach(uuid => formData.append('xls', files[uuid]));

  return wrapCall(
    api.post('/xls/dsa/import', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }),
    'import_xls_files',
    { dsa, files }
  );
};

export const downloadXLSTemplates = settings => (
  wrapCall(
    api.get(
      '/xls/dsa/download',
      settings,
      {
        responseType: 'arraybuffer',
        headers: {
          'Accept': 'application/zip'
        }
      }
    ),
    'download_xls_templates',
    { settings }
  )
);




// WEBPACK FOOTER //
// ./src/actions/xlsImportActions.js